<template>
<div class="post-preview-component" :class="{shareable: shareable}">
    <FollowFrequency v-if="post.follow_frequency" />
    <div v-if="!post.follow_frequency" :class="{'full__attachment': isFullAttachment}" class="discussion-post-card">
        <div class="discussion-post-header">
            <a class="discussion-user-info">
                <!-- <div class="discussion-avatar" :href="owner_profile_link" :style="{'background-image': `url(${post.owner.avatar})`}" /> -->
                <img :src="post.owner.avatar" class="discussion-avatar" @click="goToOwnerProfile" alt="user">
                <div class="discussion-user-meta">
                    <div class="discussion-user-name">
                        <!-- <a :href="owner_profile_link"> -->
                        <a @click="goToOwnerProfile">
                            {{ post.owner.first_name }} {{ post.owner.last_name }} 
                        </a>
                        <!-- <span v-if="group" class="group_link"> 
                            to 
                            <a
                                :href="`/groups/${group.id}`">{{ group.group_name }}
                            </a>
                        </span> -->
                    </div>
                    <div class="discussion-post-date">
                        {{ moment(post.created_at).fromNow() }}
                        <img src="~@assets/imgs/events/users-profile.svg" class="discussion-lock-icon">
                        <!-- <i class="discussion-lock-icon"
                            :class="(postFromGroup || post.privacy === 'friends') ? 'icon-friends_full' : (post.privacy === 'friends_group' ? 'icon-friends_left' : 'icon-earth')" /> -->
                    </div>
                </div>
            </a>
            <div class="discussion-post-options" @mouseleave="hideDropdown">
                <button class="btn__reset fs__20 margin-l__25" @click="toggleDropdown">
                    <img src="~@assets/imgs/events/dots-icon.svg">
                </button>
                <DropDown v-if="showDropdown" :items="dropdownContent" />
            </div>
        </div>
        <div class="discussion-post-content" :ref="'post-' + post.id">
            <a class="content_link">
                <div v-if="post.description">
                    <p v-linkified class="discussion-post-text" v-html="postText" />
                </div>
            </a>

            <span v-if="post.description.length > 490">... 
                <a href="#" class="about-read-more" @click="toggleShowMore"> 
                    {{ showMoreText }} 
                </a>
            </span>
        </div>
        <div :class="containerClass">
            <PostPreview
                v-if="post.share_post"
                :shareable="true"
                :post="post.share_post"
                :user="user" />

            <div v-if="!post.share_post">
                <TextEmbed v-if="textEmbed" :embed_url_info="textEmbed" />
                <ParsedLink :content="post" />
                <div
                    v-if="post.attachment_order_type.length && !isFullAttachment || post.attachment_order_type.length === 1"
                    class="feedAttachment">
                    <div v-if="showAttachCount" class="feedAttachment__count" @click="goToPost">
                        {{ $t('FEED.ATTACH_COUNT', {count: attachCount}) }}
                    </div>
                    <FeedAttachment :content="post" :open-post="true" />
                </div>
                <div v-if="isFullAttachment && post.attachment_order_type.length !== 1">
                    <AttachmentList :post_id="post.id" />
                </div>
            </div>
        </div>
        <div v-if="!shareable" class="discussion-post-footer">
            <button
                class="discussion-footer-btn"
                @click="toggleComments">
                <!-- <i class="icon-comment fs__18 content__sub margin-r__5" /> -->
                <img src="~@assets/imgs/events/diagram.svg" class="discussion-btn-icon" alt="elevate">
                Elevate (48)
            </button>
            <button
                class="discussion-footer-btn"
                @click="toggleComments">
                <!-- <i class="icon-comment fs__18 content__sub margin-r__5" /> -->
                <img src="~@assets/imgs/events/comment.svg" class="discussion-btn-icon" alt="comment">
                <!-- {{ $tc('FEED.COMMENT_COUNT', post.comment_count, { count: post.comment_count }) }} -->
                Comment ({{ post.comment_count }})
            </button>
            <button
                class="discussion-footer-btn"
                @click="showShareModal">
                <!-- <i class="icon-comment fs__18 content__sub margin-r__5" /> -->
                <img src="~@assets/imgs/events/export.svg" class="discussion-btn-icon" alt="share">
                Share (48)
            </button>
            <!-- <span class="likeBlock active">
                <button
                    class="btn__reset"
                    :disabled="likeLoading"
                    @click="postLike">
                    <span>
                        <i
                            v-if="!post.liked"
                            class="icon-heart" />
                        <i
                            v-if="post.liked"
                            class="icon-heart_fill">
                            <span class="path1" /><span class="path2" /><span class="path3" />
                        </i>
                    </span>
                    {{ post.likes }}
                    <LikersCount :post="post" />
                </button>
            </span> -->
            <!-- <div>
                <button
                    class="btn__reset fs__20"
                    @click="showShareModal">
                    <i class="icon-share" />
                </button>
                <div
                    class="dropdown__block dropdown__block__right"
                    @mouseleave="hideDropdown">
                    <button
                        class="btn__reset fs__20 margin-l__25"
                        @click="toggleDropdown">
                        <i class="icon-dots" />
                    </button>
                    <DropDown
                        v-if="showDropdown"
                        :items="dropdownContent" />
                </div>
            </div> -->
        </div>
        <CommentsList
            v-show="showComments"
            :load-comments="isFullAttachment"
            :pinned-comment="pinnedComment"
            :post="post"
            :user="user" />
    </div>
</div>
</template>

<script>
    import {eventBus} from '@utils/event_bus'
    import Post from '@models/Post'
    import TextEmbed from "../Preview/TextEmbed";
    import LikersCount from "../Preview/Post/LikersCount";
    import {mapGetters} from "vuex";
    const CommentsList = () => import('./comments/CommentsList')
    const FeedAttachment = () => import('./FeedAttachment')
    const DropDown = () => import('../Dropdown')
    const ParsedLink = () => import('../Preview/ParsedLink')
    const FollowFrequency = () => import('./FollowFrequency.vue')
    const AttachmentList = () => import('../Card/AttachmentList')

    export default {
        name: 'PostPreview',
        components: {
            TextEmbed,
            CommentsList,
            FeedAttachment,
            DropDown,
            ParsedLink,
            FollowFrequency,
            AttachmentList,
            LikersCount
        },
        props: {
            post: {type: Object, default: () => {}},
            user: {type: Object, default: () => {}},
            shareable: {type: Boolean, default: false},
            isFullAttachment: {type: Boolean, default: false},
            group_id: {type: String, default: null},
            pinnedComment: { type: Object, default: () => {}}
        },
        data() {
            return {
                showComments: false,
                showMore: false,
                showDropdown: false,
                likeLoading: false
            }
        },
        computed: {
            ...mapGetters('auth', {
                currentUser: 'getCurrentUser',
            }),
            attachTotal() {
              return this.post.attachment_order_id?.length || 0
            },
            showAttachCount() {
              const type = this.post.content_type
              if (['card', 'folder'].includes(type)) {
                return this.attachTotal > 1
              }
              if (type === 'photo') {
                return this.attachTotal > 2
              }
              return false
            },
            attachCount() {
              const type = this.post.content_type
              if (['card', 'folder'].includes(type)) {
                return this.attachTotal - 1
              }
              if (type === 'photo') {
                return this.attachTotal - 2
              }
              return 0
            },
            // showAttachCount () {
            //     return this.post.attachment_order_id.length > 1 ? true : false
            // },
            // attachCount () {
            //     return this.post.attachment_order_id.length - 1
            // },
            textEmbed () {
                return this.post.text_embed
            },
            postText () {
                let result = this.post.description
                this.post.mentions.map((mention) => {
                  let auth_user_id = (this.user || {}).id;
                  let link = (auth_user_id === mention.value) ? "/users/profile" : `/users/${mention.value}/other_profile`
                  let html_link = `<a target="_blank" href="${link}">${mention.label}</a>`
                  result = result.replace(`@${mention.label}`, html_link)
                })

                if (this.showMore) {
                    result = result.replace(/\n/g, '<br>')
                } else {
                    result = result.substr(0, 490).replace(/\n/g, '<br>')
                }
                return result
            },
            showMoreText () {
                return this.showMore ? this.$t('FEED.LESS') : this.$t('FEED.MORE')
            },
            group() {
              return this.post.group
            },
            postFromGroup() {
                return this.post.my_group_id
            },
            dropdownContent () {
                if (this.user && this.user.id === this.post.owner_id) {
                    return [
                        {
                            title: this.$t('FEED.EDIT_POST'),
                            action: 'entities/posts/EDIT_POST',
                            payload: this.post
                        },
                        {
                            title: this.$t('FEED.DELETE_POST'),
                            action: 'entities/posts/OPEN_DELETE_POST_MODAL',
                            payload: this.post
                        },
                    ]
                } else {
                    return [
                        {
                            title: this.$t('FEED.FLAG_POST'),
                            action: this.user ? 'entities/posts/FLAG_POST' : (()=> this.$modal.show('please-login')),
                            payload: this.post
                        }
                    ]
                }
            },
            owner_profile_link(){
              let auth_user_id = (this.user || {}).id;
              let link = (auth_user_id === this.post.owner_id) ? "/users/profile" : `/users/${this.post.owner.id}/other_profile`
              return link
            },
            containerClass() {
              return ['folder', 'card'].includes(this.post.content_type)
                ? 'keep-card-container'
                : 'discussion-post-images'
            }
        },
        mounted() {
            if (this.isFullAttachment) {
                this.toggleComments()
            }
        },
        methods: {
            showShareModal() {
                if (!this.currentUser) {
                    return this.$modal.show('please-login');
                }
              const that = this
              const dataId = this.post.id
              const data_url = `${window.location.origin}/posts/${dataId}`
              $(".modal-share-post .copy_clip").attr("data-clipboard-text", data_url);
              $(".modal-share-post #postId").val(dataId);
              const data_title = this.post.title
              const data_description = this.post.description
              $(".modal-share-post .social-share")
                  .attr("data-url", data_url)
                  .attr("data-title", data_title)
                  .attr("data-description", data_description);
              const msg_url = `${window.location.origin}/messages/new?post_id=${dataId}`
              $(".modal-share-post .btn-share-message-friend").attr("href", msg_url);

              const btnShareToFeed = $(".modal-share-post .btn-share-to-feed");
              if (this.post.privacy === "public"){
                  btnShareToFeed
                      .removeClass('hide')
                      .off("click")
                      .on("click", function (e) {
                          $(".modal-share-post").modal("hide");
                          const share_post = that.post.share_post || that.post
                          that.$modal.show('post-form', {post: {
                              share_post,
                              share_post_id: share_post.id,
                              // my_group_id: that.group_id,
                          }})
                      });
              } else {
                  btnShareToFeed.addClass('hide');
              }
              $(".modal-share-post").modal("show");
            },
            async postLike() {
                if (!this.currentUser) {
                    return this.$modal.show('please-login');
                }
                this.likeLoading = true
                await Post.dispatch('LIKE_POST', this.post.id)
                this.likeLoading = false
            },
            toggleComments() {
                this.showComments = !this.showComments
                if (this.showComments) {
                  eventBus.$emit('show-comments', {data: {post_id: this.post.id}})
                }
            },
            toggleDropdown() {
                this.showDropdown = !this.showDropdown
            },
            hideDropdown () {
                this.showDropdown = false
            },
            toggleShowMore(e) {
                e.preventDefault()
                e.stopPropagation()
                // if (this.showMore) {
                //   const el = document.querySelector(`a[href='#${this.post.id}']`)
                //   el.scrollIntoView()
                // }
                // this.showMore = !this.showMore

                if (this.showMore) {
                    this.$nextTick(() => {
                    const el = this.$refs['post-' + this.post.id]
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
                    }
                    })
                }

                this.showMore = !this.showMore
            },
            goToOwnerProfile() {
              const authUserId = (this.user || {}).id

              const path =
                authUserId === this.post.owner_id
                  ? "/users/profile"
                  : `/users/${this.post.owner.id}/other_profile`

              this.$router.push(path)
            },
            goToPost() {
              const path = `/posts/${this.post.id}`
              this.$router.push(path)
            }
        }
    }
</script>

<style lang="scss" scoped>
  .post-preview-component {
      .ava__line__mk1 {
          .ava__line__content {
              width: calc(100% - 40px);
          }
      }
      .full__attachment {
          .feedAttachment {
                max-width: 400px;
                margin: 0 auto;
          }
      }
      &.shareable {
          padding: 0 20px 0 10px;
          .tile__l {
              border: none;
              box-shadow: none;
              padding-bottom: 0;
              margin-bottom: 0;
          }
          .tile__l__head, .tile__l__body {
              padding-left: 0;
              padding-right: 0;
          }
          a {
              font-weight: unset;
              color: unset;
          }
      }
      .post-preview-component {
          &.shareable {
              padding: 0;
              .tile__l__head {
                  background: #FAF9FC;
                  padding: 10px 20px;
                  margin: 10px 0 ;

              }
          }
      }
  }


  .reset_link {
    .content_link {
      color: black;
      cursor: pointer;
      &:hover {
        color: black;
      }
    }
  }
  .break-word {
    overflow-wrap: break-word;
  }
  .icon-earth {
    left: 0px;
  }
  .icon-share {
    position: relative;
    top: 2px;
  }
  .icon-friends_left, .icon-friends_full {
    color: black;
  }
  .ava__line__content {
    .group_link {
      font-weight: normal;
    }
    a {
      font-weight: bold;
      color: black;
      &:hover {
        color: black;
      }
    }
  }

  /* ===================================
   DISCUSSION TAB PANEL STYLES
   New classes to override existing ones
   =================================== */

  /* Search Bar Row */
  .discussion-search-row {
    margin-bottom: 24px;
  }

  .discussion-search-wrapper {
    position: relative;
    background: #ffffff;
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    border: 1px solid #f2f4f7;
  }

  .discussion-search-input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 14px;
    color: #667085;
    background: transparent;
    padding: 0;
    font-weight: 400;
  }

  .discussion-search-input::placeholder {
    color: #98a2b3;
  }

  .discussion-search-icon {
    display: flex;
    align-items: center;
    margin-right: auto;
  }

  .discussion-search-icon img {
    width: 20px;
    height: 20px;
  }

  .discussion-action-icons {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .discussion-icon-btn {
    width: 20px;
    height: 20px;
    cursor: pointer;
    transition: opacity 0.2s;
  }
  .discussion-post-heading{
    font-family: "Gilroy";
    font-weight: 600;
    font-size: 18px;
    color: #414651;
  }

  .discussion-icon-btn:hover {
    opacity: 0.7;
  }

  /* Posts Row */
  .discussion-posts-row {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  /* Post Card */
  .discussion-post-card {
    background: #FFFFFFE5;
    border-radius: 28px;
    padding: 20px;
    border: none;
    backdrop-filter: blur(100px);
    box-shadow: 30px 30px 100px 0px #0000000D;
  }

  /* Collection Badge */
  .discussion-collection-badge {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    padding: 6px 12px;
    background: #f9fafb;
    border-radius: 8px;
    width: fit-content;
  }

  .discussion-collection-icon {
    width: 16px;
    height: 16px;
  }

  .discussion-collection-text {
    font-size: 13px;
    font-weight: 500;
    color: #344054;
  }

  .discussion-tag-icon {
    width: 16px;
    height: 16px;
    margin-left: auto;
  }

  /* Post Header */
  .discussion-post-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
  }

  .discussion-user-info {
    display: flex;
    gap: 12px;
    align-items: flex-start;
  }

  .discussion-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }

  .discussion-user-meta {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .discussion-user-name {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #101828;
    line-height: 20px;
  }

  .discussion-post-date {
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    color: #667085;
    line-height: 18px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .discussion-lock-icon {
    width: 14px;
    height: 14px;
  }

  .discussion-post-options {
    display: flex;
    align-items: center;

    .dropdown__content {
      text-align: left;
      position: absolute;
      top: 20%;
      left: 95%;
      background: #fff;
      box-shadow: -5px 0px 10px rgba(0,0,0,0.1);
      width: 21rem;
      border: 1px solid rgba(0,0,0,0.15);
      border-radius: 16px;
      z-index: 9;
    }
  }

  .discussion-dots-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .discussion-update-meta {
    text-align: right;
  }

  .discussion-update-label {
    margin: 0;
    font-size: 11px;
    font-weight: 400;
    color: #98a2b3;
    line-height: 16px;
  }

  .discussion-update-date {
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    color: #475467;
    line-height: 18px;
  }

  /* Post Content */
  .discussion-post-content {
    margin-bottom: 16px;
  }

  .discussion-post-title {
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 600;
    color: #101828;
    line-height: 24px;
  }

  .discussion-post-text {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #475467;
    line-height: 20px;
  }

  .discussion-read-more {
    margin: 8px 0 0 0;
    font-size: 14px;
    font-weight: 500;
    color: #6941c6;
    cursor: pointer;
    display: inline-block;
  }

  .discussion-read-more:hover {
    text-decoration: underline;
  }

  /* Post Images */
  .discussion-post-images {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 12px;
    margin-bottom: 16px;
  }

  .discussion-image-wrapper {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    aspect-ratio: 1 / 1;
  }

  .discussion-post-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  /* Post Footer */

  .discussion-footer-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #475467;
    transition: color 0.2s;
  }

  .discussion-footer-btn:hover {
    color: #101828;
  }

  .discussion-btn-icon {
    width: 20px;
    height: 20px;
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .discussion-search-wrapper {
      padding: 12px 16px;
    }

    .discussion-post-card {
      padding: 16px;
    }

    .discussion-post-images {
      gap: 8px;
    }

    .discussion-footer-btn {
      font-size: 13px;
    }

    .discussion-btn-icon {
      width: 18px;
      height: 18px;
    }
  }

  .discussion-search-wrapper {
    position: relative;
    background: #ffffffe5;
    border-radius: 200px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    border: none;
    outline: none;
    backdrop-filter: blur(100px);

    box-shadow: 30px 30px 100px 0px #0000000d;
  }

  /* Post Footer */
  .discussion-post-footer {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding-top: 24px;
  }
</style>